/* Strike: optional tee size preference. Native selectors own variant and cart behavior.
   Saves only after an explicit Remember action. No cart lines are edited here. */
(function () {
  'use strict';
  const KEY = 'strike.tee-size.v1', TTL = 180 * 86400000;
  const normalize = s => ({XXL:'2XL', XXXL:'3XL'})[String(s).trim().toUpperCase()] || String(s).trim().toUpperCase();
  const valid = s => /^(XS|S|M|L|XL|2XL|3XL|4XL|5XL)$/.test(s);
  function eligible(p) {
    const text = [p.type, p.title, ...(p.tags || [])].join(' ').toLowerCase();
    return /\b(t-shirt|tshirt|tee)\b/.test(text) &&
      !/women|ladies|crop|cut.off|hood|sweat|bundle|stack|mystery|kid|youth|baby|gift|subscription/.test(text) &&
      !p.selling_plan_groups?.length &&
      p.options?.filter(o => String(o.name || o).toLowerCase() === 'size').length === 1;
  }
  function match(p, size, current) {
    const index = p.options.findIndex(o => String(o.name || o).toLowerCase() === 'size');
    if (index < 0 || !current) return null;
    return p.variants.find(v => v.available && normalize(v.options[index]) === size &&
      v.options.every((value, i) => i === index || value === current.options[i])) || null;
  }
  function read(store, now = Date.now()) {
    try { const p = JSON.parse(store.getItem(KEY)); return p && valid(p.size) && p.expires > now && p.expires <= now + TTL ? p.size : null; }
    catch { return null; }
  }
  if (typeof window === 'undefined') { module.exports = {normalize, eligible, match, read, KEY, TTL}; return; }
  let preference = null;
  try { preference = read(localStorage); } catch {}
  const states = new WeakMap(), cache = new Map();
  let scheduled = false, applying = false;
  const explicitVariant = new URLSearchParams(location.search).has('variant');
  function save(size) {
    try { if (size) localStorage.setItem(KEY, JSON.stringify({size, expires:Date.now()+TTL})); else localStorage.removeItem(KEY); }
    catch { return false; }
    preference = size; scan(); return true;
  }
  function panel(host, state) {
    const el = document.createElement('div'); el.className = 'gb-size-memory';
    const line = document.createElement('div'); line.className = 'gb-size-memory__line';
    const label = document.createElement('label'), checkbox = document.createElement('input'); checkbox.type='checkbox';
    const text = document.createElement('span'); text.textContent='Remember my tee size'; label.append(checkbox,text);
    const clear = document.createElement('button'); clear.type='button'; clear.textContent='Clear'; clear.hidden=true;
    const note = document.createElement('p'); note.className='gb-size-memory__note'; note.setAttribute('role','status');
    line.append(label,clear); el.append(line,note); host.append(el);
    Object.assign(state,{el,checkbox,clear,note});
    checkbox.addEventListener('change', () => {
      if (!checkbox.checked) { if (!save(null)) note.textContent='Could not clear your saved size. Check browser storage settings.'; return; }
      const size=state.size();
      if (!size || !valid(size)) { checkbox.checked=false; note.textContent='Choose a tee size above first.'; return; }
      if (!save(size)) { checkbox.checked=false; note.textContent='Your browser could not save this size. You can still choose it normally.'; }
    });
    clear.addEventListener('click',()=>{ if (!save(null)) note.textContent='Could not clear your saved size. Check browser storage settings.'; });
  }
  function render(s) {
    s.checkbox.checked=!!preference; s.clear.hidden=!preference;
    let text='Optional. Saved on this browser for 180 days.';
    if(preference) text=s.unavailable ? 'Saved size '+preference+' is unavailable for this selection. Choose another size.' :
      'Saved tee size: '+preference+'. Change your selection to update it.';
    if(s.note.textContent!==text) s.note.textContent=text;
  }
  function native(host) {
    let s=states.get(host);
    if(!s) {
      let p; try { p=JSON.parse(host.querySelector('[data-gb-size-product-data]').textContent); } catch { return; }
      if(!eligible(p)) return;
      const inputs=()=>[...host.querySelectorAll('[data-single-option-selector]')];
      const sizeIndex=p.options.findIndex(o=>String(o.name||o).toLowerCase()==='size');
      const values=()=>p.options.map((_,i)=>inputs().find(e=>Number(e.dataset.position)===i+1 && (e.tagName==='SELECT'||e.checked))?.value);
      s={p,done:null,touched:false,size:()=>normalize(values()[sizeIndex]||'')}; states.set(host,s);
      panel(host,s);
      host.addEventListener('change',e=>{
        if(applying || !e.target.matches('[data-single-option-selector]')) return;
        s.touched=true; s.unavailable=false;
        if(preference && Number(e.target.dataset.position)===sizeIndex+1 && valid(s.size())) {
          if(!save(s.size())) s.note.textContent='Could not update your saved size. Your current selection still works.';
        } else render(s);
      });
      s.apply=()=>{
        if(host.dataset.gbSizeReady !== 'true' || !preference || s.done===preference || s.touched || (explicitVariant && host.closest('#MainContent'))) return;
        const valuesNow=values();
        // Wait until the native theme has selected other option axes.
        if(valuesNow.some((v,i)=>i!==sizeIndex&&!v)) return;
        const current={options:valuesNow}; const v=match(p,preference,current);
        s.done=preference; s.unavailable=!v;
        if(!v) return;
        const control=inputs().find(e=>Number(e.dataset.position)===sizeIndex+1 && (e.tagName==='SELECT'||normalize(e.value)===preference));
        if(!control||control.disabled) return;
        applying=true;
        if(control.tagName==='SELECT') {control.value=v.options[sizeIndex];control.dispatchEvent(new Event('change',{bubbles:true}));}
        else if(!control.checked) control.click();
        applying=false;
      };
    }
    if (!s.el.isConnected) panel(host,s);
    s.apply(); render(s);
  }
  async function product(path) {
    if(!cache.has(path)) cache.set(path,fetch(path+'.js',{credentials:'same-origin',signal:AbortSignal.timeout(5000)}).then(r=>r.ok?r.json():null).catch(()=>null));
    return cache.get(path);
  }
  async function recommendation(host) {
    const link=host.querySelector('.rebuy-product-title-link'), select=host.querySelector('select.rebuy-select');
    if(!link) return;
    const url=new URL(link.href,location.origin);
    url.pathname=url.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/,'');
    if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/.test(url.pathname)) return;
    // Start the read before Options is opened. No selection is changed until it is visible.
    if(!preference && !select) return;
    const p=await product(url.pathname);
    if(!p||!eligible(p)||!host.isConnected||!select||!select.isConnected) return;
    let s=states.get(select);
    if(!s) {
      const index=p.options.findIndex(o=>String(o.name||o).toLowerCase()==='size');
      const current=()=>p.variants.find(v=>String(v.id)===select.value);
      s={done:null,touched:false,size:()=>normalize(current()?.options[index]||'')}; states.set(select,s);
      panel(select.parentElement,s);
      select.addEventListener('change',()=>{
        if(applying) return; s.touched=true; s.unavailable=false;
        if(preference&&valid(s.size())) {if(!save(s.size())) s.note.textContent='Could not update your saved size.';} else render(s);
      });
      s.apply=()=>{
        if(!preference||s.done===preference||s.touched||select.dataset.gbSizeTouched) return;
        s.done=preference; const v=match(p,preference,current()); s.unavailable=!v;
        if(!v||![...select.options].some(o=>o.value===String(v.id)&&!o.disabled)) return;
        applying=true; select.value=String(v.id);select.dispatchEvent(new Event('change',{bubbles:true}));applying=false;
      };
    }
    s.apply(); render(s);
  }
  function scan() {
    document.querySelectorAll('[data-gb-size-product]').forEach(native);
    document.querySelectorAll('[data-rebuy-id="290288"] .rebuy-product-block').forEach(recommendation);
  }
  function schedule(){if(scheduled)return; scheduled=true;setTimeout(()=>{scheduled=false;scan();},120);}
  // A user's choice wins even while a recommendation product read is pending.
  document.addEventListener('change',e=>{if(!applying&&e.target.matches('[data-rebuy-id="290288"] select.rebuy-select'))e.target.dataset.gbSizeTouched='true';},true);
  new MutationObserver(records=>{
    if(records.some(r=>!r.target.closest?.('.gb-size-memory')&&([...r.addedNodes].some(n=>n.nodeType===1&&!n.matches('.gb-size-memory')) || [...r.removedNodes].some(n=>n.nodeType===1&&n.matches('.gb-size-memory')))))schedule();
  }).observe(document.body,{childList:true,subtree:true});
  ['rebuy.ready','rebuy.productsChange','rebuy:cart.show','shopify:section:load','alpine:initialized','gb:size-ready'].forEach(name=>document.addEventListener(name,schedule));
  window.addEventListener('storage',e=>{if(e.key===KEY||e.key===null){try{preference=read(localStorage);}catch{preference=null;}scan();}});
  scan(); window.addEventListener('load',schedule,{once:true});
})();
